import { render, staticRenderFns } from "./PopupRiskInfo_3x3_2.vue?vue&type=template&id=1a0c2fb7&scoped=true"
import script from "./PopupRiskInfo_3x3_2.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo_3x3_2.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo_3x3_2.vue?vue&type=style&index=0&id=1a0c2fb7&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo_3x3_2.vue?vue&type=style&index=1&id=1a0c2fb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c2fb7",
  null
  
)

export default component.exports